import * as React from "react";
import { connect } from "react-redux";
import { selectTopRewardResourcesIcon } from "../../balancingSelectors/selectBalancingRandomPools";
import { IdRandomPools } from "../../constants/IdRandomPools";
import { IdResource } from "../../constants/IdResource";
import { selectLimitedActionInfo } from "../../selectors/selectLimitedActionInfo";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { selectResourceData } from "../../selectors/selectResourceInfo";
import { LimitedActionType } from "../../utils/network/generated/protoTypes";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionDoghouseGiveRequest } from "./actionDoghouse";
import { ButtonGiveTreat } from "./ButtonGiveTreat";
import { DogCurrentState } from "./DogCurrentState";
import { DoghouseTopRewards } from "./DoghouseTopRewards";
import { DoghouseTreatInfo } from "./DoghouseTreatInfo";
var _TabDoghouseStandard = function (_a) {
    var onGiveTreat = _a.onGiveTreat, onShowAll = _a.onShowAll, freeTreatResource = _a.freeTreatResource, limitedActionInfo = _a.limitedActionInfo;
    var topRewards = selectTopRewardResourcesIcon(IdRandomPools.DogPoolStandard);
    return (React.createElement("div", { className: "dog-treat-contents-container" },
        React.createElement(DogCurrentState, null),
        React.createElement("div", { className: "dog-treat-actions-container" },
            React.createElement(DoghouseTopRewards, { onClick: onShowAll, rewards: topRewards }),
            React.createElement(DoghouseTreatInfo, { freeTreatResource: freeTreatResource, limitedActionInfo: limitedActionInfo }),
            React.createElement(ButtonGiveTreat, { onClick: onGiveTreat }))));
};
var mapState = function (state) { return ({
    doghouseMenuSelectedTab: selectModalTabId(state, IdModal.Doghouse),
    freeTreatResource: selectResourceData(state, IdResource.DogtreatStandard),
    limitedActionInfo: selectLimitedActionInfo(state, LimitedActionType.DOGHOUSE),
}); };
var mapDispatch = function (dispatch) { return ({
    onGiveTreat: function () { return dispatch(actionDoghouseGiveRequest()); },
    onShowAll: function () { return dispatch(actionModalOpen(IdModal.ShowAllRewards)); },
}); };
export var TabDoghouseStandard = connect(mapState, mapDispatch)(_TabDoghouseStandard);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/TabDoghouseStandard.tsx
// module id = 2629
// module chunks = 3